import { render, staticRenderFns } from "./CirclePlayStrokeIcon.vue?vue&type=template&id=486243f8&"
import script from "./CirclePlayStrokeIcon.vue?vue&type=script&lang=js&"
export * from "./CirclePlayStrokeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports